import axios from "axios";
import axiosRetry from "axios-retry";
import { localStorageGet } from "../utils/localStorage";
import Noti from "../view/components/general/noti";
import { general } from "../store/action/general";

// 1. Store injection
let store;
export const injectStore = (_store) => {
  store = _store;
};

// 2. Captcha Queue State
let isCaptchaModalOpen = false;
let captchaQueue = [];

/**
 * NEW: This function is called by the Modal when the user successfully solves the captcha.
 * It retries all waiting requests with the correct captcha header.
 */
export const resolveCaptchaQueue = async (captchaAnswer) => {
  const currentQueue = [...captchaQueue];
  captchaQueue = [];
  isCaptchaModalOpen = false;

  for (const req of currentQueue) {
    const retryConfig = {
      ...req.originalRequest,
      headers: {
        ...req.originalRequest.headers,
        "X-Sakhad-Captcha": captchaAnswer,
      },
    };
    try {
      const res = await axios(retryConfig);
      req.resolve(res); // Success for the original caller
    } catch (err) {
      req.reject(err); // Fail for the original caller
    }
  }
};

/**
 * NEW: This function is called if the user closes the modal without solving the captcha.
 */
export const rejectCaptchaQueue = () => {
  captchaQueue.forEach((req) =>
    req.reject({ silent: true, message: "Cancelled" }),
  );
  captchaQueue = [];
  isCaptchaModalOpen = false;
};

axiosRetry(axios, { retries: 1 });
axiosRetry(axios, { retryDelay: axiosRetry.exponentialDelay });

axios.interceptors.request.use(
  (axiosConfig) => {
    const _token = localStorageGet("USER_DATA")?.token;
    axiosConfig.timeout = 30000;
    axiosConfig.headers["HD-Authorization"] = _token || "";
    return axiosConfig;
  },
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  (response) => {
    if (response.data.status === 403) {
      window.location = `${window.location.origin}/auth/login?returnUrl=${window.location.pathname}`;
      return Promise.reject(false);
    }
    return response;
  },
  (error) => {
    const responseData = error?.response?.data;

    // Detect 429/Captcha
    if (error?.response?.status === 429 && store) {
      const captchaStr = responseData?.result?.captcha;
      if (captchaStr) {
        return handleCaptchaRequest(error.config, captchaStr);
      }
    }

    // Previous Working Logic
    if (!error?.response) {
      Noti("error", "لطفاً چند لحظه بعد دوباره تلاش کنید!");
    }

    if (error?.response?.status === 401) {
      window.location = `${window.location.origin}/auth/login?returnUrl=${window.location.pathname}`;
      return Promise.reject(false);
    }

    return Promise.reject(error?.response || error);
  },
);

function handleCaptchaRequest(originalRequest, captchaStr) {
  console.log("SAKHAD_02", captchaStr);
  return new Promise((resolve, reject) => {
    captchaQueue.push({ resolve, reject, originalRequest });

    if (!isCaptchaModalOpen) {
      isCaptchaModalOpen = true;
      // We only pass the DATA. No functions (onSubmit) are passed through Redux.
      console.log("SAKHAD_ before dispatch");
      store.dispatch(
        general.handleShowModal("sakhadVerifyCaptchaModal", {
          data: { captcha: captchaStr },
        }),
      );
      console.log("SAKHAD_ after dispatch");
    }
  });
}

export const axiosRequest = (reqType, url, data, headers) => {
  let reqData = {
    headers: headers,
    method: reqType,
    url,
    ...(data ? { data } : {}),
  };
  return axios({ ...reqData })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};
